import { SRGBColorSpace, Group, MeshBasicMaterial, PlaneGeometry, Mesh, ShaderMaterial, LinearFilter, LinearMipmapLinearFilter, ClampToEdgeWrapping } from "three";
import VaultHero from "./VaultHero";
import gsap from "gsap";

export default class CirclesLogo {
    constructor() {
        this.experience = new VaultHero()
        this.sizes = this.experience.sizes
        this.time = this.experience.time
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.originalSize = {
            'mobile': 220,
            'tablet': 220,
            'desktop': 426
        }

        this.scaleLabes = {
            'mobile': 0.6,
            'tablet': 0.6,
            'desktop': 1
        }

        this.labelsSize = [
            {
                width: 150,
                height: 122,
                positionY: 126,
            },
            {
                width: 266,
                height: 122,
                positionY: 0,
            },
            {
                width: 404,
                height: 122,
                positionY: -126,
            }
        ]

        this.meshes = [];

        this.setScale()

        this.circleSprites = [
            {
                "outerRadius": 512,
                "innerRadius": 464,
                "targetSpeed": .4,
                "currentSpeed": 0,
                "phase": "accelerate",
                "timeInPhase": 0
            },
            {
                "outerRadius": 464,
                "innerRadius": 414,
                "targetSpeed": 0.5,
                "currentSpeed": 0,
                "phase": "accelerate",
                "timeInPhase": 0
            },
            {
                "outerRadius": 414,
                "innerRadius": 364,
                "targetSpeed": -0.5,
                "currentSpeed": 0,
                "phase": "accelerate",
                "timeInPhase": 0
            },
            {
                "outerRadius": 364,
                "innerRadius": 330,
                "targetSpeed": 0.1,
                "currentSpeed": 0,
                "phase": "accelerate",
                "timeInPhase": 0
            },
            {
                "outerRadius": 330,
                "innerRadius": 300,
                "targetSpeed": -1.0,
                "currentSpeed": 0,
                "phase": "accelerate",
                "timeInPhase": 0
            },
        ]

        this.calcLogoCenter()

        this.setTexture()
        this.setGeometry()
        this.createMeshes()
        this.setLabel()
        this.animationAppear()
    }

    setTexture() {
        this.circlesTexture = this.resources.items.circlesTexture;
        this.circlesTexture.colorSpace = SRGBColorSpace;
        this.circlesTexture.generateMipmaps = true;
        this.circlesTexture.minFilter = LinearMipmapLinearFilter;
        this.circlesTexture.magFilter = LinearFilter;
        this.circlesTexture.wrapS = ClampToEdgeWrapping;
        this.circlesTexture.wrapT = ClampToEdgeWrapping;
        if (this.experience.renderer.maxAnisotropy) {
            this.circlesTexture.anisotropy = this.experience.renderer.maxAnisotropy;
        }

        this.logoTextures = [];

        this.logoTextures[0] = this.resources.items.itv_logo_1;
        this.logoTextures[1] = this.resources.items.itv_logo_2;
        this.logoTextures[2] = this.resources.items.itv_logo_3;

        this.logoTextures.forEach((texture) => {
            texture.colorSpace = SRGBColorSpace;
            texture.generateMipmaps = true;
            texture.minFilter = LinearMipmapLinearFilter;
            texture.magFilter = LinearFilter;
            texture.wrapS = ClampToEdgeWrapping;
            texture.wrapT = ClampToEdgeWrapping;
            if (this.experience.renderer.maxAnisotropy) {
                texture.anisotropy = this.experience.renderer.maxAnisotropy;
            }
        });
    }

    setLabel() {
        this.groupLogo = new Group();
        this.groupLogo.position.set(this.logoCener.x, this.logoCener.y, 0.05)
        let scale;
        if(this.sizes.scaleY < 1) {
            scale = this.scaleLabes[this.sizes.breakpoints.current];
        } else {
            scale = this.scaleLabes[this.sizes.breakpoints.current] / this.sizes.scaleY;
        }

        this.groupLogo.scale.set(scale, scale, scale);
        window.groupLogo = this.groupLogo

        this.labelsSize.forEach((label, index) => {
            const width = label.width * this.sizes.rem;
            const height = label.height * this.sizes.rem;

            const labelGeometry = new PlaneGeometry(width, height, 1, 1);

            const labelMaterial = new MeshBasicMaterial({
                map: this.logoTextures[index],
                transparent: true,
                depthWrite: false,
                depthTest: false,
                premultipliedAlpha: true,
                alphaTest: 0.001
            });

            label.labelMesh = new Mesh(labelGeometry, labelMaterial);
            label.labelMesh.position.y = label.positionY * this.sizes.rem;
            this.groupLogo.add(label.labelMesh);
        })

        this.scene.add(this.groupLogo);
    }

    calcLogoCenter() {
        if (this.sizes.breakpoints.isMobile) {
            const fromTop = 100
            this.logoCener = {
                x: 0,
                y: ((this.sizes.height - fromTop) * this.sizes.rem / this.sizes.scaleY - this.scale / this.sizes.scaleY) / 2
            };

        } else {
            const fromRight = Math.min(300, this.sizes.width * .15)
            const scaleY = Math.min(1, this.sizes.scaleY)
            this.logoCener = {
                x: (this.sizes.width - fromRight) * this.sizes.rem / 2 / scaleY - this.scale / 2 * scaleY,
                y: 0
            };
        }
    }

    createMeshes() {
        this.groupCircles = new Group();
        this.groupCircles.position.set(this.logoCener.x, this.logoCener.y, 0.05)

        let scale;

        if(this.sizes.scaleY < 1) {
            scale = this.scale;
        } else {
            scale = this.scale / this.sizes.scaleY;
        }

        this.groupCircles.scale.set(scale, scale, scale);

        this.circleSprites.forEach((sprite, index) => {
            const material = this.createCircleMaterial(this.circlesTexture, sprite.outerRadius / 512, sprite.innerRadius / 512);
            const mesh = new Mesh(this.geometry, material);
            this.groupCircles.add(mesh);
            this.meshes.push({mesh, rotationSpeed: sprite.rotationSpeed});
        });

        this.scene.add(this.groupCircles);

        window.groupCircles = this.groupCircles
    }

    setGeometry() {
        this.geometry = new PlaneGeometry(1, 1, 1, 1);
    }

    setScale() {
        this.scale = this.originalSize[this.sizes.breakpoints.current] / this.sizes.originalHeight * 2;
    }

    createCircleMaterial(circleTexture, outerRadius, innerRadius) {
        return new ShaderMaterial({
            uniforms: {
                mainTexture: {value: circleTexture},
                outerRadius: {value: outerRadius},
                innerRadius: {value: innerRadius},
            },
            transparent: true,
            alphaTest: 1,
            depthTest: false,
            depthWrite: false,
            vertexShader: `
            varying vec2 vUv;
            void main() {
                vUv = uv;
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
            }
        `,
            fragmentShader: `
            uniform sampler2D mainTexture;
            uniform float outerRadius;
            uniform float innerRadius;
            varying vec2 vUv;
            void main() {
                vec2 center = vec2(0.5, 0.5);
                float dist = distance(vUv, center) * 2.0;
                if(dist < innerRadius || dist > outerRadius) discard;
                
                vec4 color = texture2D(mainTexture, vUv);
                
                if(color.a > 0.1) {
                    color.rgb = vec3(8. / 255., 45. / 255., 66. / 255.);                
                }
                
                gl_FragColor = color;
            }
        `
        });
    }

    animationAppear() {
        this.timeline = gsap.timeline();

        const globalDelay = 1;

        this.meshes.forEach((meshData, index) => {
            const mesh = meshData.mesh;
            const delay = index * 0.2 + globalDelay;

            this.timeline.from(mesh.scale, {
                x: 0,
                y: 0,
                z: 0,
                duration: 1,
                ease: 'power2.out',
            }, delay);
        })

        const delayOffset = this.meshes.length * 0.15 + globalDelay;

        this.labelsSize.forEach((label, index) => {
            const delay = index * 0.2 + delayOffset;

            this.timeline.from(label.labelMesh.scale, {
                x: 0,
                y: 0,
                z: 0,
                duration: 1,
                ease: 'power2.out',
            }, delay);
        })

    }

    update() {
        const delta = this.time.delta * 0.001;

        this.meshes.forEach((meshData, index) => {
            const sprite = this.circleSprites[index];
            const mesh = meshData.mesh;
            switch (sprite.phase) {
                case 'accelerate':
                    sprite.currentSpeed += (sprite.targetSpeed - sprite.currentSpeed) * delta;
                    sprite.timeInPhase += delta;
                    if (sprite.timeInPhase > 2) { // Assuming 1 second to full speed; adjust as needed
                        sprite.phase = 'maintain';
                        sprite.timeInPhase = 0;
                    }
                    break;
                case 'maintain':
                    // Maintain current speed for a time before decelerating
                    sprite.timeInPhase += delta;
                    if (sprite.timeInPhase > 10) { // Maintains for 2 seconds; adjust as needed
                        sprite.phase = 'decelerate';
                        sprite.timeInPhase = 0;
                    }
                    break;
                case 'decelerate':
                    sprite.currentSpeed -= sprite.currentSpeed * delta;
                    if (Math.abs(sprite.currentSpeed) < 0.01) { // Threshold to stop deceleration
                        sprite.currentSpeed = 0;
                        sprite.targetSpeed = -sprite.targetSpeed; // Reverse direction
                        sprite.phase = 'accelerate';
                        sprite.timeInPhase = 0;
                    }
                    break;
            }

            mesh.rotation.z += sprite.currentSpeed * delta;
        });
    }

    resize() {
        this.calcLogoCenter()
        this.groupLogo.position.x = this.logoCener.x;
        this.groupLogo.position.y = this.logoCener.y;
        this.groupCircles.position.x = this.logoCener.x;
        this.groupCircles.position.y = this.logoCener.y;
    }

    breakpointChange() {
        this.setScale()

        let scale;

        if(this.sizes.scaleY < 1) {
            scale = this.scale;
        } else {
            scale = this.scale / this.sizes.scaleY;
        }

        this.groupCircles.scale.set(scale, scale, scale);

        if(this.sizes.scaleY < 1) {
            scale = this.scaleLabes[this.sizes.breakpoints.current];
        } else {
            scale = this.scaleLabes[this.sizes.breakpoints.current] / this.sizes.scaleY;
        }

        this.groupLogo.scale.set(scale, scale, scale);

        this.resize()
    }
}
